module.exports = __webpack_public_path__ + "static/media/games-lock.24f48689.png";